import type { AppUser } from '@/types/domain';
import { provider } from './client';

/**
 * Auth goes through the data provider so mock and Supabase share one surface.
 * Mock accepts any password for a seeded operator; Supabase does real
 * email/username + password auth (see SupabaseProvider.signIn).
 */
export async function signIn(login: string, password: string): Promise<AppUser> {
  return provider.signIn(login, password);
}

export async function signOut(): Promise<void> {
  return provider.signOut();
}

/** Self-service sign-up — creates an inactive receptionist account (admin approves). */
export async function signUp(input: {
  name: string;
  email: string;
  password: string;
}): Promise<void> {
  return provider.signUp(input);
}

/** Email a password-reset link (accepts email or username). */
export async function requestPasswordReset(login: string): Promise<void> {
  return provider.requestPasswordReset(login);
}

/** Set a new password for the active recovery session (reset-link landing). */
export async function updatePassword(newPassword: string): Promise<void> {
  return provider.updatePassword(newPassword);
}

/** Subscribe to the password-recovery session becoming active. Returns unsubscribe. */
export function onAuthRecovery(ready: () => void): () => void {
  return provider.onAuthRecovery(ready);
}
